import styled from 'styled-components';

export const ScTermsAndConditionsList = styled.div`
  text-transform: none;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  max-width: 600px;
  & .terms {
    display: grid;
    grid-template-rows: 1fr;

    &-content {
      overflow: hidden;
      & ol {
        text-align: left;
        list-style: none;
        & li {
          &:not(:last-child) {
            margin-bottom: 16px;
          }
        }
      }
    }
  }
`;
